import { render, staticRenderFns } from "./AppAnnotationPart6.vue?vue&type=template&id=0a2e1f0d&scoped=true"
import script from "./AppAnnotationPart6.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart6.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart6.vue?vue&type=style&index=0&id=0a2e1f0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e1f0d",
  null
  
)

export default component.exports